import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Smartphone } from "lucide-react";

function isMobileLike() {
  try { return window.matchMedia("(pointer: coarse)").matches && Math.min(window.innerWidth, window.innerHeight) < 600; }
  catch { return false; }
}

export default function OrientationGuard() {
  const { t } = useTranslation();
  const [landscape, setLandscape] = useState(false);

  // Overlay nei browser mobili ordinari: blocca le interazioni in landscape, si chiude tornando in portrait
  useEffect(() => {
    const check = () => setLandscape(isMobileLike() && window.innerWidth > window.innerHeight);
    check();
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);
    return () => {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, []);

  // Regola definitiva: dove tecnicamente supportato (PWA standalone/fullscreen e qualunque
  // contesto che consenta il lock) blocca in portrait in silenzio, senza messaggi.
  // Solo dove il lock non e' possibile (browser mobili ordinari) resta l'overlay come fallback.
  useEffect(() => {
    const tryLock = () => {
      try { window.screen?.orientation?.lock?.("portrait-primary")?.catch(() => {}); } catch { /* non supportato: resta l'overlay */ }
    };
    tryLock();
    document.addEventListener("fullscreenchange", tryLock);
    return () => document.removeEventListener("fullscreenchange", tryLock);
  }, []);

  if (!landscape) return null;
  return (
    <div className="yp-rotate-overlay" role="alertdialog" aria-modal="true" aria-labelledby="rotate-title" data-testid="orientation-overlay">
      <Smartphone size={48} strokeWidth={1.5} className="yp-rotate-icon" aria-hidden="true" />
      <h2 id="rotate-title" className="text-lg font-semibold">{t("rotate.title")}</h2>
      <p className="text-sm text-slate-300 max-w-xs">{t("rotate.message")}</p>
    </div>);
}
